import axios from "axios";

export const deleteCurrentAppointmentRequest = async (): Promise<void> => {
  await axios.delete("/api/appointments/current");
};
